import React from 'react';
import { ChatMessageList } from './ChatMessageList';
import { mockMessages, mockMessagesWithTallTable } from '../../../../__fixtures__/conversations';
const meta = {
    title: 'Features/AIChatWidget/ChatMessageList',
    component: ChatMessageList,
    decorators: [
        (Story) => (React.createElement("div", { style: { height: 400, width: 500 } },
            React.createElement(Story, null)))
    ]
};
export default meta;
export const Default = {
    args: {
        messages: mockMessages,
        isStreaming: false
    }
};
export const Streaming = {
    args: {
        messages: mockMessages,
        isStreaming: true
    }
};
export const Empty = {
    args: {
        messages: [],
        isStreaming: false
    }
};
// Reproduces IP-14201: scrollIntoView on a tall table response over-scrolls the outer
// container, pushing messages out of view and leaving a blank area.
export const WithTallTable = {
    args: {
        messages: mockMessagesWithTallTable,
        isStreaming: false
    },
    decorators: [
        (Story) => (React.createElement("div", { "data-testid": "outer-scroller", style: { height: 500, width: 500, overflowY: 'auto', background: '#f0f0f0' } },
            React.createElement("div", { style: { height: 500, overflow: 'hidden', display: 'flex', flexDirection: 'column' } },
                React.createElement(Story, null))))
    ]
};
